import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import ListaMiembrosTareaCerrar from './ListaMiembrosTareaCerrar';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        height: 140,
        width: 100
    },
    control: {
        padding: theme.spacing(2)
    }
}));

export default function FormularioCerrarTarea(props) {
    const { register, errors, defaultItem, control, id, watch } = props;
    const classes = useStyles();
    const options = [
        { idestatus: 9, label: 'Activo' },
        { idestatus: 10, label: 'Inactivo' }
    ];
    // const [value, setValue] = React.useState(options[0]);
    const [inputValue, setInputValue] = React.useState('');
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fechaActual = year + '-' + month + '-' + day;
    const horasAsignadas = watch('responsables')?.reduce((totalHoras, persona) => totalHoras + Number(persona.horas), 0) || 0;
    return (
        <Grid container className={classes.root} spacing={2}>
            <TextField
                error={false}
                defaultValue={id}
                style={{ display: 'none' }}
                id="outlined-error-helper-text"
                label="Título"
                variant="outlined"
                fullWidth
                name="idsolicitud"
                inputRef={register({
                    required: {
                        value: true,
                        message: 'Título es requerido'
                    },
                    minLength: {
                        value: 1,
                        message: 'Mínimo 1 carácteres'
                    }
                })}
            />
            <Grid item xs={12}>
                <ListaMiembrosTareaCerrar
                    control={control}
                    name="responsables"
                    rules={{ validate: responsables => responsables.every(responsable => responsable.horas > 0) || 'El registro de horas debe ser mayor 0 horas' }}
                    defaultResponsables={defaultItem.responsables}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    defaultValue={
                        defaultItem.fecha_inicio ? defaultItem.fecha_inicio : defaultItem.prop_inicio ? defaultItem.prop_inicio : null
                    }
                    id="outlined-error-helper-text"
                    label="FECHA DE INICIO"
                    variant="outlined"
                    fullWidth
                    name="fecha_inicio"
                    type="date"
                    inputRef={register({
                        required: {
                            value: true,
                            message: 'F. fin es requerida'
                        },
                        minLength: {
                            value: 1,
                            message: 'Mínimo 1 carácteres'
                        }
                    })}
                    error={Boolean(errors.fecha_inicio)}
                    helperText={errors.fecha_inicio}
                />
                {/* {errors.prop_fin && <p style={{color:"red"}}>"Campo requerido" </p>} */}
            </Grid>
            <Grid item xs={4}>
                <TextField
                    defaultValue={
                        defaultItem.fecha_termino ? defaultItem.fecha_termino : defaultItem.prop_fin ? defaultItem.prop_fin : null
                    }
                    id="outlined-error-helper-text"
                    label="FECHA DE TÉRMINO"
                    variant="outlined"
                    fullWidth
                    name="fecha_termino"
                    type="date"
                    inputRef={register({
                        required: {
                            value: true,
                            message: 'F. fin es requerida'
                        },
                        minLength: {
                            value: 1,
                            message: 'Mínimo 1 carácteres'
                        }
                    })}
                    error={Boolean(errors.fecha_termino)}
                    helperText={errors.fecha_termino}
                />
                {/* {errors.prop_fin && <p style={{color:"red"}}>"Campo requerido" </p>} */}
            </Grid>
            <Grid item lg={4} xs={4}>
                <Typography variant="caption"># HORAS TRABAJO</Typography>
                <br />
                <Typography variant="body1">{horasAsignadas}</Typography>
            </Grid>
        </Grid>
    );
}
